import { ReactAppMode } from "Interfaces/ReactAppModes";
import { handleOMvcLogOut, handleVcapLogOut } from "./service.utils";
import { EXEC_MODE } from "cfg";
import { parseJwt } from "Utils";
import axios, { AxiosRequestConfig } from "axios";
import LoadingService from "./loading.service";

axios.interceptors.request.use(
    (config: AxiosRequestConfig) => {
        LoadingService.increment();
        const token = window.sessionStorage.getItem('EXP_API_TKN');
        const parsedToken: any = token ? parseJwt(token) : null;
        const expSeconds = parsedToken && parsedToken.exp ? Number(parsedToken.exp) : null;
        if (expSeconds !== null && !isNaN(expSeconds)) {
            const expTimestampMs = expSeconds * 1000;
            const expDate = new Date(expTimestampMs);
            const now = Date.now();
            const diffMs = expTimestampMs - now;
            const diffSec = Math.max(0, Math.floor(diffMs / 1000));
            const diffMin = Math.floor(diffSec / 60);

            // If Token is expired
            if (diffMs <= 0) {
                // Below works only for OMVC
                if (EXEC_MODE === ReactAppMode.VOA) {
                    handleOMvcLogOut();
                    return Promise.reject({ message: 'Access Token Expired!', code: 401 });
                // Below condition is for VCAP
                } else if (EXEC_MODE === ReactAppMode.VCAP || EXEC_MODE === ReactAppMode.LOCAL) {
                    handleVcapLogOut();
                    return Promise.reject({ message: 'Access Token Expired!', code: 401 });
                }
            // If token is not expired
            } else {
                console.log('token expires in', `${diffMin}m ${diffSec % 60}s`, `(${diffSec}s)`);
            }
        } else {
            console.log('parsedToken exp not found or invalid', parsedToken);
        }
        return config;
    },
    (error: any) => {
        LoadingService.decrement();
        console.error('request interceptor error', error);
        return Promise.reject(error);
    },
);

axios.interceptors.response.use(
    (response) => {
        LoadingService.decrement();
        return response;
    },
    (error: any) => {
        LoadingService.decrement();
        return Promise.reject(error);
    },
);